<template>
  <div class="box">
    <div>
      <div class="iconStyle">
        <Icon type="md-checkmark" size="50" />
      </div>
      <h1 class="text">提交成功</h1>
      <div class="text"><a @click="jumpDetail">进入审批详情</a></div>
      <div>
        <Button @click="jump('launchApproval')" style="margin-right: 10px">继续发起</Button>
        <Button @click="jump('approvalTask')">任务列表</Button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
export default {
  data() {
    return {
      instApplyId: '',
      permission: [] // 权限
    };
  },
  methods: {
    // 跳转
    jump(type) {
      if (type == 'approvalTask' && !this.jumpBeforeRoute('approvalTask')) {
        this.$Message.error('没有权限');
        return;
      }
      this.$router.push(`/${type}`);
    },
    jumpDetail() {
      this.$router.push({ path: '/approvalDetail', query: { instApplyId: this.instApplyId } });
    },
    jumpBeforeRoute(menuCode) {
      let flag = false;
      this.permission.forEach(item => {
        if (item.menuCode == menuCode) {
          flag = true;
        }
      });
      return flag;
    },
    getPermission() {
      store.dispatch('GetMenuList').then(res => {
        this.permission = res;
      });
    }
  },
  mounted() {
    const { instApplyId } = this.$route.query;
    this.instApplyId = instApplyId;
    this.getPermission();
    // console.log('store', store._modules.root.state.permission.promiseMenu);
  }
};
</script>

<style scoped>
.box{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.iconStyle{
  width: 80px;
  height: 80px;
  background: #ddd;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  text-align: center;
    margin: 14px 0;
}
</style>
